// Lightweight GA4 event helper.
// gtag is loaded in public/index.html (G-9VEW2S2WN3). This is a safe no-op
// when gtag is unavailable (local dev, ad-blockers, SSR/prerender), so call
// sites never need to guard.
export function track(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (_) {
    /* never let analytics break the UI */
  }
}
